import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import Image from 'next/image';
import { useI18n } from '@/hooks/use-i18n';

// 自定义事件名称
export const OPEN_ADD_CUSTOMER_MODAL_EVENT = 'openAddCustomerModal';

interface addCustomerData {
  name: string;
  text: React.ReactNode;
}

interface AddCustomerModalProps {
  isOpen: boolean;
  data?: addCustomerData;
  title?: string;
  onClose: () => void;
}

export function triggerAddCustomerModal({
  data,
  title,
}: Omit<AddCustomerModalProps, 'isOpen' | 'onClose'>) {
  const event = new CustomEvent(OPEN_ADD_CUSTOMER_MODAL_EVENT, {
    detail: {
      data,
      title,
    },
  });
  window.dispatchEvent(event);
}

const AddCustomerModal = (props: AddCustomerModalProps) => {
  const { t } = useI18n('thread');
  const { isOpen, onClose, data, title } = props;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="w-100 p-0 border-0 bg-transparent overflow-hidden gap-0"
        closeClassName="top-7 text-white"
      >
        <DialogHeader className="h-18 flex items-center justify-center bg-primary rounded-t-lg border-0">
          <DialogTitle className="text-center text-lg font-semibold text-white">
            {title || t('addCustomerModal.defaultTitle')}
          </DialogTitle>
        </DialogHeader>
        <div className="min-h-60 flex flex-col items-center px-8 pb-[38px] pt-2 bg-white rounded-b-lg pt-4">
          {!!data?.name && (
            <div className="text-[14px] text-[rgba(0,0,0,0.75)] w-full">
              {data?.name}：
            </div>
          )}
          <div className="text-[14px] text-[rgba(0,0,0,0.75)] w-full mb-6">
            {data?.text}
          </div>
          <Image
            src="/service_qrcode.png"
            alt="qrcode"
            width={240}
            height={240}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const AddCustomerModalWrapper = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [customerModalProps, setCustomerModalProps] =
    useState<AddCustomerModalProps>();

  const handleOpenCustomerModal = (event: CustomEvent) => {
    const { data, title } = event.detail;
    console.log(111, event.detail);
    setIsOpen(true);
    setCustomerModalProps({
      isOpen: true,
      data,
      title,
      onClose: () => setIsOpen(false),
    });
  };

  useEffect(() => {
    window.addEventListener(
      OPEN_ADD_CUSTOMER_MODAL_EVENT,
      handleOpenCustomerModal,
    );
    return () => {
      window.removeEventListener(
        OPEN_ADD_CUSTOMER_MODAL_EVENT,
        handleOpenCustomerModal,
      );
    };
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <AddCustomerModal
      isOpen={isOpen}
      data={customerModalProps?.data}
      title={customerModalProps?.title}
      onClose={customerModalProps?.onClose}
    />
  );
};

export default AddCustomerModal;
